import React from "react";
import styled from "styled-components";
import Splash from "../../shared/Splash";
import Footer from "../../shared/Footer";
import Content from "./components/Content";
import Banner from "./components/Banner";
import banner1 from "../../../assets/corpBanner2.jpg";
import banner2 from "../../../assets/corpBanner3.jpg";
import banner3 from "../../../assets/corpBanner4.jpg";
import circle from "../../../assets/circle.svg";
import puzzle from "../../../assets/puzzle.svg";
import dollarSign from "../../../assets/dollarSign.svg";
import Form from "../../shared/Form";
import Helmet from "react-helmet";
import corpBanner from "../../../assets/corpBanner.jpg";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

// const text = [
//   ``,
//   ``
// ];

export default function Corporate() {
  return (
    <Wrapper>
      <Helmet
        title="AchieveCE | Approved Continuing Education"
        meta={[
          { name: "description", content: "Corporate Page for AchieveCE" },
          { property: "og:type", content: "website" },
          { property: "og:title", content: "Approved Continuing Education" },
          { property: "og:url", content: "http://achievece.com/corporate" }
        ]}
      />
      <Splash
        text={[
          "Provide your employees with a CONVENIENT CE Solution.",
          `Whether you own your own practice or lead a national organization, we are happy to work with you to create a custom solution for your licensed professionals.`
        ]}
        img={corpBanner}
        id="corporate"
      />
      <Content />
      <Banner
        img={banner1}
        icon={circle}
        title="Focus"
        text="Are you looking to ensure that your licensees have a clear area of focus? We’re able to develop custom content that is specific to your needs."
        id="banner1"
      />
      <Banner
        img={banner2}
        icon={puzzle}
        title="Simplicity"
        text="Get your own custom branded portal that is organized around the needs of your licensees."
        id="banner2"
      />
      <Banner
        img={banner3}
        icon={dollarSign}
        title="Pricing"
        text="We offer multiple pricing models which can be customized to fit the needs of your unique organization. "
        id="banner1"
      />
      <Form
        title="Request a consultation"
        text="Request a consultation to discuss your custom CE solution."
        type="corp"
      />
      <Footer />
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Corporate/Corporate.jsx